import type { NumberToChineseLabels } from ".";

const labels: NumberToChineseLabels = {
  digits: ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
  units: [
    "",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿",
    "十",
    "百",
    "千",
    "兆",
    "十",
    "百",
    "千",
    "京",
    "十",
    "百",
    "千",
    "垓",
  ],
  ordinal: "第",
  point: "点",
  minus: "负",
};

export default labels;
